import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n/suppressSupportNotice';
import './i18n/config';
import './index.css'; // MOVED UP - Must be loaded early for glassmorphism
import './styles/reset.css';
import './styles/browser-compatibility.css';
import './styles/performance-enhancements.css';
import './styles/print.css';
import './styles/Dashboard.css';
import './styles/responsive.css';
import './styles/dark-mode.css';
import './styles/accessibility.css';
import './styles/rangeInput.css';

// PDF.js worker yapılandırmasını import et
import './utils/pdfjs-worker';

// Security initialization
import { initializeSecurity } from './utils/securityMiddleware';

// DOM Safety utilities
import './utils/domSafetyUtils';

// Test utilities (development only)
if (import.meta.env.DEV) {
  import('./utils/testHelpers');
}

// CSS Diagnostic (always run to debug)
import('./utils/cssGlassmorphismDiagnostic');

// Production monitoring
import './services/productionMonitor';

// Diagnostics
import { monitorChunkLoading } from './utils/diagnostics';
import { initializeRuntimeStability, isChunkLoadError } from './utils/runtimeStability';

// Initialize security measures
initializeSecurity();
initializeRuntimeStability();

// Passive event listener fix for better performance
if (typeof window !== 'undefined') {
  // Override addEventListener to make touch events passive by default
  const originalAddEventListener = EventTarget.prototype.addEventListener;
  EventTarget.prototype.addEventListener = function(type: string, listener: any, options?: any) {
    if (type === 'touchstart' || type === 'touchmove' || type === 'wheel' || type === 'mousewheel') {
      if (typeof options === 'object' && options !== null) {
        options.passive = options.passive !== false;
      } else if (typeof options === 'boolean') {
        options = { capture: options, passive: true };
      } else {
        options = { passive: true };
      }
    }
    return originalAddEventListener.call(this, type, listener, options);
  };
}

// Monitor chunk loading in development
if (import.meta.env.DEV) {
  monitorChunkLoading();
}

// Cache temizleme - sayfa yüklendiğinde
if (sessionStorage.getItem('cache_clear_needed') === 'true') {
  sessionStorage.removeItem('cache_clear_needed');
  sessionStorage.removeItem('error_reload_count');
  sessionStorage.removeItem('last_reload_time');
  
  // Service Worker cache temizle (kullanıcı verisi korunur)
  if ('caches' in window) {
    caches.keys().then(names => {
      names.forEach(name => {
        if (!name.includes('user-data')) {
          caches.delete(name);
        }
      });
    });
  }
}

// Global error handler for DOM issues
window.addEventListener('error', (event) => {
  if (event.error && event.error.message && event.error.message.includes('className.split')) {
    event.preventDefault();
  }
  
  // Chunk loading hatalarını yakala
  if (event.error && event.error.message && 
      (event.error.message.includes('Unexpected token') ||
       event.error.message.includes('Loading chunk') ||
       event.error.message.includes('Failed to fetch dynamically imported module'))) {
    // Diagnostics
    import('./utils/diagnostics').then(({ logChunkLoadingError }) => {
      logChunkLoadingError(event.error, event.filename || undefined);
    });
  }
});

// Enhanced unhandled promise rejection handler
window.addEventListener('unhandledrejection', (event) => {
  // Supabase multiple instance uyarılarını bastır
  if (event.reason && typeof event.reason === 'string' && 
      (event.reason.includes('Multiple GoTrueClient') || 
       event.reason.includes('GoTrueClient instances'))) {
    event.preventDefault();
    return;
  }
  
  if (isChunkLoadError(event.reason)) {
    event.preventDefault();
  }
});

// Doğrudan login sayfasına yönlendirme için
window.addEventListener('DOMContentLoaded', () => {
  if (window.location.pathname === '/') {
    window.location.href = '/auth/login';
  }
});



import ErrorBoundary from './components/ErrorBoundary';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);

